import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { BaseEntityResponseDto } from '@sphere/shared/domain';

export class LearningPathStepResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string' })
  pathId!: string;

  @ApiProperty({ type: 'string' })
  activityId!: string;

  @ApiProperty({ type: Number })
  orderInPath!: number;

  @ApiPropertyOptional({ type: Boolean })
  isOptional?: boolean;

  @ApiPropertyOptional({ type: Number, nullable: true })
  minScore?: number | null;
}

